import React from "react";
import { Select, MenuItem, Box, Typography } from "@mui/material";

const SailingDropdown = ({
  sailingData = [],
  packageId,
  setPackageId,
  sailingDate,
  setSailingDate,
}) => {
  const formatDate = (dateStr) => {
    const [year, month, day] = dateStr.split("-");
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return `${day} ${months[+month - 1]} ${year}`;
  };

  return (
    <div className="fieldrow">
      <Select
        // required
        style={{ width: "100%", height: "45px" }}
        value={packageId ?? ""} // Allow empty/null values
        onChange={(e) => {
          const selectedValue = e.target.value;

          if (selectedValue === "") {
            // Handle empty selection
            setPackageId(null); // or "" depending on your preference
            setSailingDate(""); // or null
          } else {
            // Handle valid selection
            const selected = sailingData.find(
              (item) => item.packageId === selectedValue
            );
            setPackageId(selectedValue);
            setSailingDate(selected?.sailingDate || "");
          }
        }}
        renderValue={(selectedId) => {
          if (!selectedId) return ""; // Show blank if null/empty
          const sel = sailingData.find((item) => item.packageId === selectedId);
          if (!sel) return "";
          return `${sel.packageName} ${new Date(
            sel.sailingDate
          ).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}`;
        }}
        displayEmpty // This ensures the placeholder shows even when value is empty
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left", // keep anchored to the field
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          PaperProps: {
            sx: {
              width: 500,
              marginLeft: "20px", // shift popup 20px to right
            },
          },
        }}
      >
        {/* Placeholder option for empty state */}
        <MenuItem value="">
          <em>Select Sailing</em>
        </MenuItem>

        {sailingData.map((item, index) => {
          const duration = item.packageName.match(/(\d+)\s*Night/i)?.[1] || "";
          const route = item.packageName
            .replace(/^\d+\s*Night[s]?\s*/i, "")
            .split("-")
            .filter((dest) => dest.trim() !== "")
            .join(" → ");

          return (
            <MenuItem key={index} value={item.packageId}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography variant="body2" fontWeight="medium">
                  {duration} Night{duration !== "1" ? "s" : ""} • {route}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ ml: 2 }}
                >
                  {formatDate(item.sailingDate)}
                </Typography>
              </Box>
            </MenuItem>
          );
        })}
      </Select>
    </div>
  );
};

export default SailingDropdown;
